<template>
	<div>
		<pui-datatable
			:modelName="modelName"
			:modelColumnDefs="modelColumnDefs"
			:externalFilter="externalFilter"
			:masterDetail="masterDetail"
			:parentModelName="parentModelName"
			:masterDetailColumnVisibles="masterDetailColumnVisibles"
			:modalDialog="modalDialog"
			:showDeleteBtn="false"
			:navigableDetail="false"
			:showCreateBtn="false"
			:showToolbar="false"
			:showPaginator="false"
		></pui-datatable>
	</div>
</template>

<script>
import { PuiGridDetailMixin } from '@Pui9Datatables';

export default {
	name: 'edimensajeerror-grid',
	mixins: [PuiGridDetailMixin],
	data() {
		return {
			modelName: 'edimensajeerror',
			modelColumnDefs: {
			},
			masterDetailColumnVisibles: {
				codedierror:true,
				destipoerror:true,
				error:true
			}
		}
	}
}
</script>
